import React, { useEffect, useRef, useState } from 'react'
import ContentHeader from '../../Layout/ContentHeader'
import Box from '../../Global/Box'
import FormWizard from 'react-form-wizard-component'
import FormCitizen from '../Components/FormCitizen'
import FormProcesses from '../Components/FormProcesses'
import { useHistory } from 'react-router-dom'
import { useLoading } from '../../../LoadingOverlay/LoadingOverlayContext'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'
import { CREATE_PROCESS_REQUESTS } from '../../../graphql/Catalog/Processes/Requests/ProcessesRequests'
import { useMutation } from '@apollo/client'
import FormAttachments from '../Components/FormAttachments'

const ProcessesRequests = () => {
  const refWizard = useRef()
  const history = useHistory()

  const { showLoading, hideLoading } = useLoading()
  const [isValidSteps, setIsValidSteps] = useState({
    stepProcess: false,
    stepCitizen: false,
    stepAttachments: false,
  })
  const [dataSteps, setDataSteps] = useState({
    stepProcess: null,
    stepCitizen: null,
    stepAttachments: [],
  })

  const [createRequest] = useMutation(CREATE_PROCESS_REQUESTS)

  useEffect(() => {
    if (
      isValidSteps.stepProcess &&
      isValidSteps.stepCitizen &&
      isValidSteps.stepAttachments
    ) {
      let input = {}

      input = {
        external_folio: dataSteps.stepProcess.external_folio,
        citizen_id: +dataSteps.stepCitizen.citizen_id,
        process_id: +dataSteps.stepProcess.process_id,
        process_category_id: +dataSteps.stepProcess.process_category_id,
        process_sub_category_id: +dataSteps.stepProcess.process_sub_category_id,
        process_sub_category_children_id:
          +dataSteps.stepProcess.process_sub_category_children_id,
        inputCitizenRequest: {
          name: dataSteps.stepCitizen.name,
          last_name: dataSteps.stepCitizen.last_name,
          email: dataSteps.stepCitizen.email,
          phone: dataSteps.stepCitizen.phone,
          address_full: dataSteps.stepCitizen.address_full,
          coordinates: dataSteps.stepCitizen.coordinates,
          address: dataSteps.stepCitizen.address,
        },
        attachmentsProcessRequest: dataSteps.stepAttachments,
      }

      onSubmit(input)
    }
  }, [dataSteps])

  const onSubmit = async (data) => {
    showLoading()
    try {
      const { data: dataCreate } = await createRequest({
        variables: {
          input: data,
        },
      })

      if (dataCreate.createProcessRequest) {
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Solicitud creada correctamente',
          },
          history.push('/processesrequests')
        )
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader
        title={'Solicitudes de trámites'}
        windowTitle="Solicitudes de trámites"
        breadcrumb=""
      />
      <Box
        title={
          dataSteps.stepProcess
            ? `${dataSteps.stepProcess.process_name} - ${
                dataSteps.stepProcess.category_name
              } - ${dataSteps.stepProcess.sub_category_name} - 
              ${
                dataSteps?.stepProcess?.sub_category_children_name &&
                `${dataSteps?.stepProcess?.sub_category_children_name} -`
              } ${dataSteps.stepProcess.external_folio || 'TZ-91092'}`
            : 'Solicitudes de trámites'
        }
        content={
          <FormWizard
            ref={refWizard}
            shape="circle"
            color="#e74c3c"
            title={false}
            onComplete={() => null}
            onTabChange={() => null}
            backButtonTemplate={() => null}
            nextButtonTemplate={() => null}
            finishButtonTemplate={() => null}
            finishButtonText={() => null}
            subtitle="HOLA"
          >
            <FormWizard.TabContent
              title="Datos trámite"
              icon="fas fa-envelope-open-text"
            >
              <FormProcesses
                refWizard={refWizard}
                data={dataSteps}
                setData={setDataSteps}
                setIsValidSteps={setIsValidSteps}
              />
            </FormWizard.TabContent>
            <FormWizard.TabContent title="Datos Solicitante" icon="fa fa-user">
              <FormCitizen
                refWizard={refWizard}
                data={dataSteps}
                setData={setDataSteps}
                setIsValidSteps={setIsValidSteps}
              />
            </FormWizard.TabContent>
            <FormWizard.TabContent
              title="Subida de archivos"
              icon="fa fa-upload"
            >
              <FormAttachments
                refWizard={refWizard}
                data={dataSteps}
                setData={setDataSteps}
                setIsValidSteps={setIsValidSteps}
                maxFiles={30}
              />
            </FormWizard.TabContent>
          </FormWizard>
        }
      />
    </>
  )
}

export default ProcessesRequests
